export default "__VITE_ASSET__502520ff__"